import React from 'react'
import AccPic from '../../assets/images/accOpening.jpg'
import PdfPage from '../../components/PdfPage'

const DownloadAccOpening = () => {
  return (
    <main>
      <PdfPage
        h2={"DOWNLOAD ACCOUNT OPENING FORM"}
        h1={'Download our account opening form to get started with your new account. Complete the form and submit it to our office.'}
        img={AccPic}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/document-for-account-opening.pdf"}
        pdf1Text={"Document for account opening"}
      />
    </main>)
}

export default DownloadAccOpening